<template>
  <div class="container">
    <!-- 文章详情 -->
    <div class="vue">
      <el-row>
        <el-col :span="16" :offset="4" class="padVertical10">
          <div class="head flex flexJc-sb padVertical10">
            <div class="head-left flex flexAi-c">
              <div class="icon"></div>
              <span class="primaryCol FontW6">服务资讯</span>
            </div>
            <div class="head-right flex flexAi-c">
              <span class="title">当前位置：</span>
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }"
                  >首页</el-breadcrumb-item
                >
                <el-breadcrumb-item>服务资讯</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
          </div>
          <div class="form-data">
            <div class="title FontW6 textA-C">{{ ArticleData.name }}</div>
            <div class="textA-C time">
              发布时间：{{ ArticleData.createTime | FilterDataTime }}
            </div>
            <!-- <span class="padHorizontal10">文章作者：</span> -->
            <div v-html="ArticleData.text"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { apiArticleFindById } from '@/api/webViews'
export default {
  name: '',
  props: [''],
  data() {
    return {
      titleName: '文章详情',
      ArticleData: '',
      IsHome: ''
    }
  },

  components: {},

  computed: {},

  beforeMount() {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.IsHome = from.path
      console.log(vm.IsHome)
    })
  },
  mounted() {
    this.ArticleFindById()
  },

  methods: {
    // 取消
    cancelClick() {
      this.$router.go(-1)
    },
    ArticleFindById() {
      apiArticleFindById({
        id: this.$route.query.id
      }).then(res => {
        this.ArticleData = res.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-col {
  .head {
    border-bottom: 1px solid #cdcdcd;
    .head-left {
      /deep/ .icon {
        height: 20px;
        width: 3px;
        background: #018b43;
      }
      span {
        padding-left: 10px;
        font-size: 20px;
      }
    }
    .head-right {
      .title {
        color: #a2a2a2;
      }
    }
  }
  .form-data {
    padding: 20px 0;
    padding-bottom: 40px;
    .title {
      font-size: 24px;
    }
    .time {
      padding: 20px 0;
    }
  }
}
</style>
